import * as Yup from "yup";
import {
    dateCantBeInFuture,
    dateIsBefore
} from "./validationFunctions";

export const informationToReleaseValidations = section => {
    if (section.active) {
        return Yup.object().shape({
            releaseFromDate: section.fields.releaseFromDate.validations.required.value && Yup.date()
                .required(
                    () =>
                        section.fields.releaseFromDate.validations.required.message
                ).nullable()
                .max(
                    dateCantBeInFuture,
                    section.fields.releaseFromDate.validations.notFutureDate.message
                )
                .test(
                    "releaseFromDate",
                    section.fields.releaseFromDate.validations.notFutureDate.message,
                    function (date) {
                        var todaysDate = new Date();
                        var enteredDate = new Date(date);
                        return todaysDate > enteredDate;
                    }
                ),
            releaseToDate: section.fields.releaseToDate.validations.required.value && Yup.date()
                .required(
                    () =>
                        section.fields.releaseToDate.validations.required.message
                ).nullable()
                .max(
                    dateCantBeInFuture,
                    section.fields.releaseToDate.validations.notFutureDate.message
                )
                .test(
                    "afterFromDate",
                    section.fields.releaseToDate.validations.notBeforeDate.message,
                    function (releaseToDate) {
                        const { releaseFromDate } = this.parent;
                        if (releaseFromDate && releaseToDate) {
                            return dateIsBefore(releaseFromDate, releaseToDate);
                        }
                    }
                )
                .test(
                    "afterFromDate",
                    section.fields.releaseToDate.validations.notFutureDate.message,
                    function (date) {
                        var todaysDate = new Date();
                        var enteredDate = new Date(date);
                        return todaysDate > enteredDate;
                    }
                ),

            infoToReleaseGroup: Yup.array()
                .test("infoToReleaseGroup", "Please select at least one item of information for release.",
                    function (item) {
                        const { infoToReleaseGroupOther } = this.parent;

                        if ((item || "").length + (infoToReleaseGroupOther || "").length > 0) {
                            return true;
                        }
                        return false;
                    }
                )
        });
    } else {
        return Yup.object().shape();
    }
}
